import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  priority?: boolean;
}

export default function Logo({ className = '', size = 'md', priority = false }: LogoProps) {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/');
  };

  const sizes = {
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-12'
  };

  return (
    <Link 
      to="/"
      onClick={handleClick}
      className={`inline-block ${className}`}
    >
      <img 
        src="https://ofertium.es/images/ofertium-logo.svg" 
        alt="Ofertium" 
        className={`${sizes[size]} transition-transform hover:scale-105 will-change-transform`}
        loading={priority ? 'eager' : 'lazy'}
        fetchpriority={priority ? 'high' : 'auto'}
        decoding={priority ? 'sync' : 'async'}
      />
    </Link>
  );
}